import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const WarehouseLocationRoutes = defineRoute({
    record: {
        route: {
            path: "/warehouse-location",
            component: () => loadView(import("./WarehouseLocationTable.vue")),
        },
    },
    create: {
        route: {
            path: "/warehouse-location/create",
            component: () => loadView(import("./WarehouseLocationCreate.vue")),
        },
    },
    update: {
        route: {
            path: "/warehouse-location/update/:id",
            component: () => loadView(import("./WarehouseLocationUpdate.vue")),
        },
        build(id: string) {
            return `/warehouse-location/update/${id}`;
        },
    },
});
